<div class="container-fluid modal-container">
    <div>
        <h2 class="heading text-center top-margin-0">How does this work?</h2>
    </div>

    <div class="row top-padding-10px">
        <div class="col-12">
            You can transfer money to your finzy wallet via the unique Virtual Account Number assigned to your finzy
            investment
            account. This works like any other beneficiary account.
        </div>
    </div>

    <div class="row top-padding-10px">
        <div class="col-12">
            To add money to your finzy wallet -
        </div>
        <ol class="col-12">
            <li> Add the Virtual Account Number assigned to you as a beneficiary in your bank account</li>
            <ul>
                <li> Payee Account Name is "Bridge Fintech Solutions Pvt Ltd"</li>

                <li> Payee Account Number is your unique Virtual Account ID displayed on the dashboard</li>
            </ul>

            <li> Make a transfer to the Virtual Account (using NEFT/IMPS/RTGS)</li>

            <li> Once the funds are credited to the finzy Escrow account, we will automatically update your wallet to
                reflect the same and you can start investing!
            </li>
        </ol>

    </div>

    <div class="row top-padding-10px">
        Note: Some banks might not allow adding Virtual Account IDs as a new beneficiary on their mobile app. In such a
        case, you might have to login using the web version of the bank to add the beneficiary

        For more information on Virtual Account, please check our <a (click)="closeDialog()" routerLink="/faq" target="_blank"
                                                                    class="faq" [queryParams]="{selectedTab: 'INVESTOR'}">FAQs</a>.
    </div>

    <div class="row top-padding-10px flex-wrapper top-padding-20px">
        <button mat-flat-button class="primary" (click)="closeDialog()">
            OK
        </button>
    </div>
</div>
